import { render, staticRenderFns } from "./VideoHD.vue?vue&type=template&id=f32e717e&"
import script from "./VideoHD.vue?vue&type=script&lang=js&"
export * from "./VideoHD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports